import * as React from 'react';
import styled from '@emotion/styled';
import { ChartLegend, HorizontalGaugeBarChart } from '@liveoptics/react-ui';
import { HorizontalGaugeBarSeries } from '@liveoptics/react-ui/dist/types/interfaces/Charts';

const ChartContainer = styled.div`
  padding: 90px 0px 0px 0px;
  display: block;
`;

const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const ChartLabel = styled.div`
  top: 327px;
  left: 117px;
  height: 19px;
  padding-right: 100px;
  text-align: left;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.28px;
  color: #566072;
  opacity: 1;
`;

interface Props {
  data: HorizontalGaugeBarSeries[];
  showGraph: boolean;
}
const legendItems = [
  { color: '#27C595', label: 'Outlier' },
  { color: '#4694CE', label: 'Standard' }
];

class VmResourceDistributionGraph extends React.Component<Props> {
  render() {
    if (this.props.showGraph) {
      return (
        <ChartContainer>
          {this.props.data.length !== 0 && (
            <>
              <ChartHeader>
                <ChartLabel>
                  VMs are classified as outlier if either the vCPU, Memory, or Provisioned Storage is
                  greater than the 95<sup>th</sup>% of its peers. To learn more about how to read
                  this chart see our{' '}
                  <a href="https://www.dell.com/support/kbdoc/000233559">blog</a>.
                </ChartLabel>
                <ChartLegend legendItems={legendItems} />
              </ChartHeader>
              <HorizontalGaugeBarChart series={this.props.data}></HorizontalGaugeBarChart>
            </>
          )}
        </ChartContainer>
      );
    } else {
      return <div></div>;
    }
  }
}

export default VmResourceDistributionGraph;
